import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
let default_1 = class default_1 extends Vue {
    listCard;
    firstTabName;
    activeTab = PortraitCenterModule.activeTab;
    onChangefirstTabName(val) {
        this.activeTab = val;
    }
    changeActiveTab() {
        PortraitCenterModule.getActiveTab(this.activeTab);
    }
};
__decorate([
    Prop()
], default_1.prototype, "listCard", void 0);
__decorate([
    Prop()
], default_1.prototype, "firstTabName", void 0);
__decorate([
    Watch('firstTabName')
], default_1.prototype, "onChangefirstTabName", null);
default_1 = __decorate([
    Component({
        name: 'zoneTab',
        i18n: { messages: lang },
    })
], default_1);
export default default_1;
